import { useState, useCallback } from 'react';
import { FormData, FormFiles } from '../types/ContactForm';

export const useFormData = () => {
  const [formData, setFormData] = useState<FormData>({});
  const [files, setFiles] = useState<FormFiles>({});

  const handleInputChange = useCallback((name: string, value: any) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleFileChange = useCallback((name: string, file: File | File[] | null) => {
    if (file === null || (Array.isArray(file) && file.length === 0)) {
      setFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[name];
        return newFiles;
      });
    } else {
      setFiles(prev => ({ ...prev, [name]: file }));
    }
  }, []);

  const resetFormData = useCallback(() => {
    setFormData({});
    setFiles({});
  }, []);

  return {
    formData,
    files,
    handleInputChange,
    handleFileChange,
    resetFormData
  };
}; 